import React from 'react';
import { Link } from 'react-router-dom';
import { useUserSessionContext } from '../../contexts/UserSessionContext/UserSessionContext';
import Text from '../Text';

import './DiscountBanner.scss';

const className = 'c-DiscountBanner';

const text = [
  {
    text: 'You are entitled for a 20% discount for all Nas Academy courses. ',
  },
  {
    text: 'Browse Courses',
    isAnchorText: true,
  },
];

const DiscountBanner = () => {
  const { sessionHomePageLogoLink } = useUserSessionContext();

  return (
    <div className={className}>
      <Link to={sessionHomePageLogoLink}>
        <Text text={text} />
      </Link>
    </div>
  );
};

export default DiscountBanner;
